import { combineReducers } from 'redux';
import types from './types';
import INITIAL_STATE, { IInitialState } from 'src/store/initialState';
import { INewPasswordValidation } from 'src/model/modules/accountview.model';
import { type } from 'os';

export interface IWarrantyError {
  hasFailed: boolean;
  message: string;
}

const INITIAL_IS_PENDING = false;
const INITIAL_ERROR: IWarrantyError = {
  hasFailed: false,
  message: ''
};

const INITIAL_NEW_PASSWORD_VALIDATION = {
  valid: false,
  dirty: false,
  message: ''
};

const INITIAL_ADDRESS_REQUEST = {
  address: {
    address: '',
    address2: '',
    addressId: 0,
    city: '',
    country: '',
    customerName: '',
    customerNumber: 0,
    state: '',
    zipCode: ''
  },
  addressValidation: {
    address: { invalid: true, message: '' },
    city: { invalid: true, message: '' },
    country: { invalid: true, message: '' },
    customerName: { invalid: true, message: '' },
    state: { invalid: true, message: '' },
    zipCode: { invalid: true, message: '' }
  },
  succed: false,
  failed: false
};

const DELIVERY_STATUS = {
  accountId: '',
  deliverCompleteFlag: false
};
const CREDIT_CARD_STATUS = true;

const isPending = (
  state: boolean = INITIAL_IS_PENDING,
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_IS_PENDING:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const error = (
  state: IWarrantyError = INITIAL_ERROR,
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_ERROR:
      return payload;
      break;

    default:
      return state;
      break;
  }
};

const menuOption = (
  state: IInitialState['accountView']['menuOption'] = INITIAL_STATE.accountView
    .menuOption || 'info',
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_MENU_OPTION: {
      return payload;
    }
    default:
      return state;
  }
};

const currentPassword = (
  state: IInitialState['accountView']['currentPassword'] = INITIAL_STATE
    .accountView.currentPassword || '',
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_CURRENT_PASSWORD: {
      return payload;
    }
    default:
      return state;
  }
};

const newPassword = (
  state: IInitialState['accountView']['newPassword'] = INITIAL_STATE.accountView
    .newPassword || '',
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_NEW_PASSWORD: {
      return payload;
    }
    default:
      return state;
  }
};

const newPasswordRepeat = (
  state: IInitialState['accountView']['newPasswordRepeat'] = INITIAL_STATE
    .accountView.newPasswordRepeat || '',
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: string;
  }
) => {
  switch (type) {
    case types.SET_NEW_PASSWORD_REPEAT: {
      return payload;
    }
    default:
      return state;
  }
};

const newPasswordValidation = (
  state: IInitialState['accountView']['newPasswordValidation'] = INITIAL_STATE
    .accountView.newPasswordValidation || INITIAL_NEW_PASSWORD_VALIDATION,
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: INewPasswordValidation;
  }
) => {
  switch (type) {
    case types.SET_NEW_PASSWORD_VALIDATION: {
      return payload;
    }
    default:
      return state;
  }
};

const addressRequest = (
  state: IInitialState['accountView']['addressRequest'] = INITIAL_STATE
    .accountView.addressRequest || INITIAL_ADDRESS_REQUEST,
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_SHIP_ADDRESS: {
      return { ...state, address: payload };
    }
    case types.SET_SHIP_ADDRESS_SUCCED: {
      return { ...state, succed: payload };
    }
    case types.SET_SHIP_ADDRESS_FAILED: {
      return { ...state, failed: payload };
    }
    case types.SET_SHIP_ADDRESS_VALIDATION: {
      return { ...state, addressValidation: payload };
    }
    default:
      return state;
  }
};

const deliveryStatus = (
  state: IInitialState['accountView']['deliveryStatus'] = INITIAL_STATE
    .accountView.deliveryStatus || DELIVERY_STATUS,
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_DELIVERY_STATUS: {
      return payload;
    }
    default:
      return state;
  }
};

const creditCardStatus = (
  state: IInitialState['accountView']['creditCardStatus'] = INITIAL_STATE
    .accountView.creditCardStatus || CREDIT_CARD_STATUS,
  {
    // tslint:disable-next-line: no-shadowed-variable
    type,
    payload
  }: {
    type: string;
    payload: any;
  }
) => {
  switch (type) {
    case types.SET_CC_STATUS: {
      return payload;
    }
    default:
      return state;
  }
};

export default combineReducers({
  menuOption,
  isPending,
  error,
  currentPassword,
  newPassword,
  newPasswordRepeat,
  newPasswordValidation,
  addressRequest,
  deliveryStatus,
  creditCardStatus
});
